module.exports = __webpack_public_path__ + "img/headset-gray.b5fb408d.svg";